import React, { useContext, useEffect, useMemo, useState } from "react";
import { Avatar, Box, Button, FileInput, Form, FormField, Select, Header, Heading, TextArea, TextInput, DropButton, Nav, ResponsiveContext, Text, Layer, Stack } from "grommet";
import { MoreVertical, Logout, FormNext, Notification } from "grommet-icons";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../redux/actions/userActions";
import { FeedbackCard } from "../../feedback";
import { NotificationLayer } from ".";
import { announcementService } from "../../../services";
import { sessionService } from "redux-react-session";
import { fetchNotifications } from "../../../redux/actions/notificationActions";

export const HeaderNav = () => {
	const [notificationsLength, setNotificationLength] = useState(null)
	const dispatch = useDispatch();
	const notifications = useSelector((state) => {
		return state.notification.notifications
	})
	const user = useSelector((state) => {
		return state.session.user;
	});
	const history = useHistory()
	const size = useContext(ResponsiveContext);
	const [open, setOpen] = useState();

	const [openPopup, setOpenPopup] = useState(false);
	const [openNotification, setOpenNotification] = React.useState();

	const onOpenNotification = () => {
		setOpenNotification(true);
		setTimeout(() => {
			setOpenNotification(undefined);
		}, 3000);
	};
	const onCloseNotification = () => setOpenNotification(undefined);

	const [showModal, setShowModal] = useState(false);
	const [is_Admin, setIsAdmin] = useState(false)
	useEffect(() => {
		if (user.user && user.user.user_role && user.user.user_role.role_name && String(user.user.user_role.role_name).startsWith('Admin')) {
			setIsAdmin(true)
		}
		if (user.access) {
			dispatch(fetchNotifications(user.access))
		}
	}, [user, dispatch])
	useEffect(() => {
		if (Array.isArray(notifications) && notifications.length > 0) {
			setNotificationLength(notifications.length)
		}
	}, [notifications, setNotificationLength])
	function onClickHandler() {
		setShowModal(false)
	}
	const logout = () => {
		dispatch(userActions.logout());
		history.push("/index");
	};
	return (
		<>
			{openPopup && (
				<FeedbackCard setPopup={setOpenPopup} openPopup={openPopup} setNotification={onOpenNotification} />
			)}
			<Nav align='center' direction='row' gap='small'>
				{size !== "xsmall" && !is_Admin && (
					<>
						<Button
							size={size === "small" ? "small" : "medium"}
							a11yTitle='Feedback'
							primary
							label='Feedback'
							onClick={() => {
								setShowModal(true);
							}}
						/>
					</>
				)}

				{openNotification && (
					<NotificationLayer
						notificationMessage={"Feedback submitted successfully!"}
						closeNotification={onCloseNotification}
					/>
				)}
				{size === "small" || size === "xsmall" || size === "medium" ? <DropButton
					dropContent={<UserDetails size={size} />}
					dropProps={{ align: { top: "bottom", right: "right" } }}
					open={open}
					onOpen={() => setOpen(true)}
					onClose={() => setOpen(false)}
					icon={<MoreVertical />}
				/> : <>
					<Box justify="end" direction="row" gap="small">
						<Stack anchor="top-right">
							{/* <Box direction="row" pad={"small"} onClick={() => {
								history.push('/notification-center')
							}}>
								<Box direction="row" gap="small" align="center" >
									<Notification />
								</Box>
							</Box> */}
							<Button icon={<Notification />} tip={"Notification"} onClick={() => {
								history.push('/notification-center')
							}
							} />
							{notificationsLength ? <Box background="status-warning" pad={{ horizontal: 'xxsmall' }} round>
								<Text size="xsmall">{notificationsLength}</Text>
							</Box> : <></>}
						</Stack>
						<Button icon={<Logout />} tip={"Logout"} onClick={() => {
							logout()
						}} />
					</Box>
				</>}
				{/* <Stack anchor="top-right">
					<Button icon={<MoreVertical />} />
					<Box background="orange" pad={{ horizontal: 'xxsmall' }} round>
						<Text size="xsmall">4</Text>
					</Box>
				</Stack> */}
				{/* {user && (
					<Avatar background='blue!' flex={false}>
						{user.family_name && user.given_name && (
							<Text size='large' color='text-strong'>
								{user.given_name[0] + user.family_name[0]}
							</Text>
						)}
					</Avatar>
				)} */}
				{showModal &&
					<Layer>
						<FormForStory onClickHandler={onClickHandler} onSubmitted={onOpenNotification} />
					</Layer>}
			</Nav>
		</>
	);
};
const FormForStory = ({ onClickHandler, onSubmitted }) => {
	const size = useContext(ResponsiveContext);
	const user = useSelector((state) => state.session.user);
	const competitors = useSelector((state) => state.competitiveDash.competitors);
	const [formValues, setFormValues] = useState({});
	const [numFiles, setNumFiles] = useState(0);
	const [submitting, setSubmitting] = useState(false);
	const [errors, setErrors] = useState(null);
	const onFormChange = value => {
		setFormValues(value);
	};

	const sortedCompetitors = useMemo(
		() => [...(Array.isArray(competitors.data) ? competitors.data : [])]
			.sort((a, b) => a.competitor_name.localeCompare(b.competitor_name)),
		[competitors.data]
	);
	const fieldError = (name) => (errors && errors[name] ? [].concat(errors[name]).join(" ") : undefined);

	const onSubmit = ({ value }) => {
		const competitor = sortedCompetitors.find((c) => c.competitor_name === value.competitor);
		setSubmitting(true);
		setErrors(null);
		announcementService.submitUserFeedback(user.access, {
			competitorId: competitor ? competitor.id : "",
			feedback: (value.comments || "").trim(),
			file: value.fileinput && value.fileinput[0],
		})
			.then(() => {
				onClickHandler();
				if (onSubmitted) onSubmitted();
			})
			.catch((error) => {
				setErrors(error.fieldErrors || { non_field_errors: [error.message] });
				setSubmitting(false);
			});
	};
	useEffect(() => {
		if (user) {
			setFormValues({
				name: user.name,
				email: user.user.email,
				fileinput: '',
				comments: ''
			})
		}
	}, [user])
	return (
		<>
			<Box gap="medium" width="medium" pad={"medium"}>
				<Header
					direction="column"
					align="start"
					gap="xxsmall"
					pad={{ horizontal: 'xxsmall' }}
				>
					<Heading level={2} margin="none">
						Tell Us Your Story
					</Heading>
				</Header>
				<Box
					// Padding used to prevent focus from being cutoff
					pad={{ horizontal: 'xxsmall' }}
				>
					<Form
						messages={{
							required: 'This is a required field.',
						}}
						onSubmit={({ value, touched }) => onSubmit({ value, touched })}
						value={formValues}
						onChange={onFormChange}
						method="post"
						encType="multipart/form-data"
					>
						<FormField
							required
							// error="Provide a unique name."
							htmlFor="name"
							name="name"
							label="Name"
						>
							<TextInput id="name" name="name" value={user.name} />
						</FormField>
						<FormField required htmlFor="email" name="email" label="Email">
							<TextInput id="email" name="email" value={user.user.email} />
						</FormField>
						<FormField
							required
							htmlFor="competitor__input"
							name="competitor"
							label="Competitor"
							error={fieldError("competitor_id")}
						>
							<Select options={sortedCompetitors.map((c) => c.competitor_name)} id="competitor" name="competitor" />
						</FormField>
						<FormField required htmlFor="comments" name="comments" label="Tell Us Your Story" error={fieldError("feedback")}>
							<TextArea
								id="comments"
								name="comments"
								placeholder="Enter your story"
								maxLength={1000}
							/>
						</FormField>
						<FormField
							htmlFor="fileinput"
							name="fileinput"
							label="Upload a file"
							error={fieldError("upload_document")}
						>
							<FileInput
								messages={{
									dropPrompt: 'Drag and drop',
									browse: numFiles > 0 ? 'Replace file' : 'Select file',
								}}
								id="fileinput"
								onChange={(event, { files }) => setNumFiles(files.length)}
								name="fileinput"
							/>
						</FormField>
						{errors && errors.non_field_errors && (
							<Text color="status-critical">{[].concat(errors.non_field_errors).join(" ")}</Text>
						)}
						<Box
							align={!['xsmall', 'small'].includes(size) ? 'start' : undefined}
							margin={{ top: 'medium', bottom: 'small' }}
							direction="row"
							justify="between"
						>
							<Button label={submitting ? "Sending..." : "Send"} primary type="submit" disabled={submitting} />
							<Button label="Close" secondary onClick={() => { onClickHandler() }} disabled={submitting} />
						</Box>
					</Form>
				</Box>
			</Box>
		</>
	);
}
const UserDetails = ({ size, ...rest }) => {
	const user = useSelector((state) => {
		return state.session.user;
	});
	const history = useHistory();
	const dispatch = useDispatch();

	const logout = () => {
		dispatch(userActions.logout());
		history.push("/index");
	};

	return (
		<>
			<Box width='medium'>
				{user && user.user && (
					<Box pad='medium' direction='row' gap='small' align="center">
						<Avatar background='blue!' flex={false} size='medium'>
							{user.family_name && user.given_name && (
								<Text size='large' color='text-strong'>
									{user.given_name[0] + user.family_name[0]}
								</Text>
							)}
						</Avatar>

						<Box pad={{ vertical: "small" }}>
							<Text color='text-strong' size='large' weight='bold'>
								{`${user.name}`}
							</Text>
							<Text size='small'>{user.user.email}</Text>
						</Box>
					</Box>
				)}
				<Box
					border={{
						side: "top",
						color: "border-weak",
					}}
					// align='end'
					// justify-content='right'
					gap="small"
					pad={{ horizontal: "xsmall", vertical: "small" }}
				>
					<Stack anchor="top-right">
						<Box direction="row" justify="between" gap="xlarge" width={"medium"} pad={"small"} onClick={() => {
							history.push('/notification-center')
						}}>
							<Box direction="row" gap="small" align="center">
								<Notification />
								<Text>Notification</Text>
							</Box>
							<FormNext />
						</Box>
						<Box background="status-warning" pad={{ horizontal: 'xxsmall' }} round>
							<Text size="xsmall">4</Text>
						</Box>
					</Stack>
					<Box direction="row" justify="between" gap="xlarge" width={"medium"} pad={"small"} onClick={logout}>
						<Box direction="row" gap="small" align="center">
							<Logout />
							<Text>Logout</Text>
						</Box>
						<FormNext />
					</Box>
				</Box>
			</Box></>
	);
};
